import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import WalletIcon from "@material-ui/icons/Flight";
import Reconciliation from "@material-ui/icons/RestorePage";
import Landing from "@material-ui/icons/FlightLandOutlined";
import Audit from "@material-ui/icons/TrackChanges";
import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";
import NotFound from "views/NotFound/Index.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import WalletReport from "views/WalletReport";
import StatementOfAccount from "views/StatementOfAccount/Index.jsx"
import HelpCenter from "../views/HelpCenter";
import HelpIcon from "@material-ui/icons/HelpOutline"


// These routes are used by monitoring staff/personnel role
const routes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
    subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
    subMenu: [],
    component: SettlementPage
  },
  {
    path: "/app/statement-of-account",
    sidebarName: "Account Statement",
    isNotVisible: false,
    navbarName: "Account Statement",
    icon: Reconciliation,
    component: StatementOfAccount,
    subMenu: []
  },
  {
      path: "/app/wallet-report",
      sidebarName: "Airline Wallet Report",
      isNotVisible: false,
      navbarName: "Airline Wallet Report",
      icon: WalletIcon,
      component: WalletReport,
      subMenu: [],

  },
  {
    path: "/app/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
    ];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/airline.jsx